export default "__VITE_ASSET__BD$75OFn__"